import { useMemo } from 'react';
import { imageUrl, srcSet } from '../lib/images';
import { pick } from '../lib/content';

export default function RichText({ value, className = '' }) {
  const html = pick(value);
  const optimized = useMemo(() => {
    if (!html || typeof DOMParser === 'undefined') return html;
    // CMS rich text is sanitized by the platform. Adjust only image delivery and legacy hrefs.
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('img').forEach((img) => {
      const original = img.getAttribute('src');
      if (!original) return;
      img.setAttribute('src', imageUrl(original, 'width=900,quality=80,format=auto'));
      img.setAttribute('srcset', srcSet(original, [360, 720, 1200]));
      img.setAttribute('sizes', '(min-width: 900px) 720px, 90vw');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
    });
    doc.querySelectorAll('a[href]').forEach((link) => {
      try {
        const href = new URL(link.getAttribute('href'), window.location.origin);
        if (href.hostname === 'salonk9.dk' || href.hostname === 'www.salonk9.dk') {
          link.setAttribute('href', `${href.pathname}${href.search}${href.hash}`);
        }
      } catch { /* Keep relative, mailto and tel links as supplied. */ }
    });
    // A CMS editor can create headings, but a route's page header owns its only H1.
    doc.querySelectorAll('h1').forEach((heading) => {
      const h2 = doc.createElement('h2');
      h2.innerHTML = heading.innerHTML;
      heading.replaceWith(h2);
    });
    return doc.body.innerHTML;
  }, [html]);

  if (!optimized) return null;
  return <div className={`cms-copy ${className}`} dangerouslySetInnerHTML={{ __html: optimized }} />;
}
